// ** Initial State
const initialState = {
  allData: [],
  data: [],
  total: 1,
  params: {},
  selectedCompany: null,
  availableUsers: []
}

const companies = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_ALL_DATA':
      return { ...state, allData: action.data }
    case 'GET_COMPANIES':
      return {
        ...state,
        data: action.data,
        total: action.totalPages,
        params: action.params
      }
    case 'ADD_USER':
      return { ...state }
    case 'DELETE_COMPANY':
      return { ...state }
    case 'ADD_USER_COMPANY':
      return { ...state }
    case 'DELETE_USER_COMPANY':
      return { ...state }
    case 'GET_COMPANY':
      return { ...state, selectedCompany: action.selectedCompany }
    case 'EDIT_COMPANY':
      return { ...state }
    case 'GET_AVAILABLE_USERS':
      return { ...state, availableUsers: action.availableUsers }
    default:
      return { ...state }
  }
}
export default companies
